import { type Client, graphql, prefetch } from "@opensea/graphql"
import { ItemOwnedQuantityFragment } from "../../utils"
import { CollectionItemsCardFragment } from "../CollectionItemsGrid"
import { CollectionItemsTableRowFragment } from "../CollectionItemsTable"
import { collectionItemsPurchaseSelectionFragment } from "../collection-items-purchase-selection-store"
import { collectionItemsSellSelectionFragment } from "../collection-items-sell-selection-store"
import { PAGE_SIZE } from "../constants"

export const CollectionItemsListQuery = graphql(
  `
    query CollectionItemsListQuery(
      $cursor: String
      $sort: CollectionItemsSort!
      $filter: CollectionItemsFilter
      $collectionSlug: String!
      $limit: Int
      $address: Address
    ) {
      collectionItems(
        collectionSlug: $collectionSlug
        cursor: $cursor
        sort: $sort
        filter: $filter
        limit: $limit
      ) {
        items {
          id
          ...CollectionItemsCardFragment
          ...CollectionItemsTableRowFragment
          rarity {
            rank
          }
          createdAt
          lastSaleAt
          lastTransferAt
          ...ItemOwnedQuantity
          enforcement {
            isDelisted
            isCompromised
          }
          bestListing {
            pricePerItem {
              token {
                unit
              }
            }
            startTime
            marketplace {
              identifier
            }
          }
          bestOffer {
            pricePerItem {
              usd
              token {
                unit
              }
            }
          }
          lastSale {
            native {
              unit
            }
          }
          version
          ...collectionItemsPurchaseSelection
          ...collectionItemsSellSelection
        }
        nextPageCursor
      }
    }
  `,
  [
    CollectionItemsCardFragment,
    CollectionItemsTableRowFragment,
    collectionItemsPurchaseSelectionFragment,
    collectionItemsSellSelectionFragment,
    ItemOwnedQuantityFragment,
  ],
)

export const prefetchCollectionItemsListQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionItemsListQuery, {
    limit: PAGE_SIZE,
    sort: { by: "PRICE", direction: "ASC" },
    collectionSlug,
  })
}
